import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {EventLogService} from './services/eventLog.service';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../../../environments/environment';


@Component({
  selector: 'app-eventlog-view',
  templateUrl: './eventlog-view.component.html',
  styleUrls: ['./eventlog-view.component.css']
})
export class EventLogViewComponent implements OnInit {

  loading: boolean;
  eventLogList: any [];
  campaignId: any;
  campaignNumber: any;
  clientId: any;
  itemsPageCount = 1;
  itemsPerPage = 10;
  noOfEventLogs=0;
  currentPage = 1;
  status='';
  regExp = '';
  eventLogStatus: any = [
    { id: '1', value: 'EVENT' },
    { id: '2', value: 'ALERT' },
    { id: '3', value: 'DEBUG' },
    { id: '4', value: 'ERROR' }
  ];

    constructor(private router: Router,
              private eventLogService: EventLogService,
              private toastr: ToastrService,
              private _route: ActivatedRoute) {

        this._route.queryParams.subscribe(params => {
          this.campaignId = params['campaignId'] || '';
          this.campaignNumber = params['campaignNumber'] || '';
        });

        this._route.params.subscribe(routeParams => {this.clientId = routeParams.clientIdParam; });
        this.clientId = this.clientId !== undefined ? this.clientId : localStorage.getItem('clientId');
  }

  ngOnInit() {
    this.getAllEventLogs();
  }

  pageChanged(event) {
        this.currentPage = event;
        this.getAllEventLogs();
        console.log(event);
    }

  public onChangeStatusFilter(status){
      this.status=status;
      this.getAllEventLogs();
  }

  public search(){
      this.getAllEventLogs();
  }


  public getAllEventLogs() {
    this.loading = true;
      if (this.clientId === undefined) {
          this.clientId = localStorage.getItem('clientId');
      }
    this.eventLogService.getAllEventLogs(this.campaignId, this.clientId, this.status, this.regExp, this.currentPage -1 , this.itemsPerPage)
        .subscribe(data => {
          const response: any = data.json();
          this.eventLogList = response.eventLogList;
          this.noOfEventLogs = response.numberOfEventLog;
          this.loading = false;
          // TODO - Uncomment below code when using actual API
          // const response: any = data;
          // if (response.status === 200) {
          //   this.userList = response.result;
          // } else {
          //   this.toastr.error('', 'Please try again');
          // }
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }

}
